module.exports = {"513327100":"新都镇","513327101":"朱倭镇","513327102":"斯木镇","513327200":"泥巴乡","513327201":"雅德乡","513327202":"洛秋乡","513327204":"宜木乡","513327205":"仁达乡","513327207":"旦都乡","513327208":"充古乡","513327209":"更知乡","513327210":"卡娘乡","513327211":"宗塔乡","513327212":"宗麦乡","513327213":"上罗柯马乡","513327214":"下罗柯马乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513327.json
// module id = 2418
// module chunks = 0